import { useContext, useMemo } from 'react';

import { NetworkStatusContext } from '../../components/NetworkStatusContext/NetworkStatusContext';

export const useNetworkStatus = () => {
  const context = useContext(NetworkStatusContext);

  if (!context) {
    throw new Error('useNetworkStatus must be used within a NetworkStatusProvider');
  }

  const { isOnline, setMode, mode, isConnectedToInternet } = context;

  return useMemo(
    () => ({
      isConnectedToInternet,
      isOnline,
      mode,
      setMode,
    }),
    [isConnectedToInternet, isOnline, mode, setMode]
  );
};
